"use client";

import { c as _c } from "react/compiler-runtime";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import { useEmoji } from "@/contexts/EmojiContext";
import type { ApiDropReaction } from "@/generated/models/ApiDropReaction";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useMemo, useState } from "react";
interface WaveDropReactionsDetailDialogProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly reactions: ApiDropReaction[];
  readonly initialReaction?: string | undefined;
}
export default function WaveDropReactionsDetailDialog(t0) {
  const $ = _c(23);
  const {
    isOpen,
    onClose,
    reactions,
    initialReaction
  } = t0;
  const [selectedReaction, setSelectedReaction] = useState(initialReaction ?? reactions[0]?.reaction ?? "");
  let t1;
  let t2;
  if ($[0] !== initialReaction || $[1] !== isOpen) {
    t1 = () => {
      if (isOpen && initialReaction) {
        setSelectedReaction(initialReaction);
      }
    };
    t2 = [isOpen, initialReaction];
    $[0] = initialReaction;
    $[1] = isOpen;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== reactions || $[5] !== selectedReaction) {
    let t4;
    if ($[7] !== selectedReaction) {
      t4 = r => r.reaction === selectedReaction;
      $[7] = selectedReaction;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = reactions.find(t4);
    $[4] = reactions;
    $[5] = selectedReaction;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const selectedReactionData = t3;
  let t4;
  if ($[9] !== reactions || $[10] !== selectedReaction) {
    t4 = <ReactionsSidebar reactions={reactions} selectedReaction={selectedReaction} onSelectReaction={setSelectedReaction} />;
    $[9] = reactions;
    $[10] = selectedReaction;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== selectedReactionData?.profiles) {
    t5 = selectedReactionData?.profiles ?? [];
    $[12] = selectedReactionData?.profiles;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <ProfilesList profiles={t5} />;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <div className="tw-flex tw-h-[50vh] tw-max-h-[400px]">{t4}{t6}</div>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== isOpen || $[20] !== onClose || $[21] !== t7) {
    t8 = <MobileWrapperDialog title="Reactions" isOpen={isOpen} onClose={onClose}>{t7}</MobileWrapperDialog>;
    $[19] = isOpen;
    $[20] = onClose;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
function ReactionsSidebar(t0) {
  const $ = _c(9);
  const {
    reactions,
    selectedReaction,
    onSelectReaction
  } = t0;
  let t1;
  if ($[0] !== onSelectReaction || $[1] !== reactions || $[2] !== selectedReaction) {
    let t2;
    if ($[4] !== onSelectReaction || $[5] !== selectedReaction) {
      t2 = reaction => <ReactionButton key={reaction.reaction} reaction={reaction} isSelected={reaction.reaction === selectedReaction} onClick={() => onSelectReaction(reaction.reaction)} />;
      $[4] = onSelectReaction;
      $[5] = selectedReaction;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = reactions.map(t2);
    $[0] = onSelectReaction;
    $[1] = reactions;
    $[2] = selectedReaction;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="tw-w-32 tw-flex-shrink-0 tw-border-r tw-border-solid tw-border-iron-700 tw-border-t-0 tw-border-b-0 tw-border-l-0 tw-overflow-y-auto tw-px-2 tw-py-2"><div className="tw-flex tw-flex-col tw-gap-y-1">{t1}</div></div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function ReactionButton(t0) {
  const $ = _c(26);
  const {
    reaction,
    isSelected,
    onClick
  } = t0;
  const {
    emojiMap,
    findNativeEmoji
  } = useEmoji();
  let t1;
  if ($[0] !== reaction.reaction) {
    t1 = reaction.reaction.replaceAll(":", "");
    $[0] = reaction.reaction;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const emojiId = t1;
  let t2;
  bb0: {
    let t3;
    if ($[2] !== emojiId || $[3] !== emojiMap) {
      let t4;
      if ($[5] !== emojiId) {
        t4 = e => e.id === emojiId;
        $[5] = emojiId;
        $[6] = t4;
      } else {
        t4 = $[6];
      }
      t3 = emojiMap.flatMap(_temp).find(t4);
      $[2] = emojiId;
      $[3] = emojiMap;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const custom = t3;
    const customSrc = custom?.skins[0]?.src;
    if (customSrc) {
      let t4;
      if ($[7] !== customSrc || $[8] !== emojiId) {
        t4 = <div className="tw-relative tw-size-5"><Image src={customSrc} alt={emojiId} fill={true} className="tw-object-contain" /></div>;
        $[7] = customSrc;
        $[8] = emojiId;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      t2 = t4;
      break bb0;
    }
    let t4;
    if ($[10] !== emojiId || $[11] !== findNativeEmoji) {
      t4 = findNativeEmoji(emojiId);
      $[10] = emojiId;
      $[11] = findNativeEmoji;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    const native = t4;
    if (native) {
      const t5 = native.skins[0]?.native;
      let t6;
      if ($[13] !== t5) {
        t6 = <span className="tw-flex tw-items-center tw-justify-center tw-text-lg">{t5}</span>;
        $[13] = t5;
        $[14] = t6;
      } else {
        t6 = $[14];
      }
      t2 = t6;
      break bb0;
    }
    t2 = null;
  }
  const emojiNode = t2;
  const t3 = isSelected ? "tw-bg-primary-500/20 tw-text-iron-50" : "tw-bg-transparent tw-text-iron-300 hover:tw-bg-iron-800";
  let t4;
  if ($[15] !== t3) {
    t4 = clsx("tw-flex tw-items-center tw-justify-between tw-gap-x-2 tw-rounded-lg tw-border-0 tw-px-2 tw-py-1.5 tw-transition-colors tw-cursor-pointer", t3);
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== emojiNode) {
    t5 = <div className="tw-flex tw-items-center tw-justify-center tw-size-6">{emojiNode}</div>;
    $[17] = emojiNode;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== reaction.profiles.length) {
    t6 = <span className="tw-text-sm tw-font-medium">{reaction.profiles.length}</span>;
    $[19] = reaction.profiles.length;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== onClick || $[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
    t7 = <button type="button" onClick={onClick} className={t4}>{t5}{t6}</button>;
    $[21] = onClick;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}
function _temp(cat) {
  return cat.emojis;
}
function ProfilesList(t0) {
  const $ = _c(4);
  const {
    profiles
  } = t0;
  let t1;
  if ($[0] !== profiles) {
    t1 = profiles.map(_temp2);
    $[0] = profiles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tw-flex-1 tw-overflow-y-auto tw-px-4 tw-py-2"><div className="tw-flex tw-flex-col tw-gap-y-2">{t1}</div></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2(profile) {
  return <ProfileItem key={profile.id} profile={profile} />;
}
function ProfileItem(t0) {
  const $ = _c(18);
  const {
    profile
  } = t0;
  const displayName = profile.handle ?? profile.id;
  const profileLink = profile.handle ? `/${profile.handle}` : null;
  let t1;
  if ($[0] !== displayName || $[1] !== profile.pfp) {
    t1 = <div className="tw-size-8 tw-flex-shrink-0 tw-rounded-full tw-overflow-hidden tw-bg-iron-800">{profile.pfp ? <img src={getScaledImageUri(profile.pfp, ImageScale.W_AUTO_H_50)} alt={displayName} className="tw-h-full tw-w-full tw-object-cover" /> : <div className="tw-h-full tw-w-full tw-bg-iron-700" />}</div>;
    $[0] = displayName;
    $[1] = profile.pfp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== displayName) {
    t2 = <span className="tw-text-sm tw-font-medium tw-text-iron-50 tw-truncate">{displayName}</span>;
    $[3] = displayName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== profile.handle) {
    t3 = profile.handle && <span className="tw-text-xs tw-text-iron-400 tw-truncate">{profile.handle}</span>;
    $[5] = profile.handle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-min-w-0">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-3 tw-py-1">{t1}{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const content = t5;
  if (profileLink) {
    let t6;
    if ($[13] !== content || $[14] !== profileLink) {
      t6 = <Link href={profileLink} className="tw-no-underline hover:tw-bg-iron-800 tw-rounded-lg tw-px-2 tw--mx-2 tw-transition-colors">{content}</Link>;
      $[13] = content;
      $[14] = profileLink;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  let t6;
  if ($[16] !== content) {
    t6 = <div className="tw-px-2 tw--mx-2">{content}</div>;
    $[16] = content;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}